import { render, staticRenderFns } from "./FooterShare.vue?vue&type=template&id=74a56736"
import script from "./FooterShare.vue?vue&type=script&lang=js"
export * from "./FooterShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports